// extracted by mini-css-extract-plugin
export var carouselWrapper = "Carousel-module--carouselWrapper--CBrLu";
export var container = "Carousel-module--container--H0vAD";
export var slide = "Carousel-module--slide--K6pRF";
export var viewport = "Carousel-module--viewport--KLn7N";